// extracted by mini-css-extract-plugin
export var box = "FeaturedPanel-module--box--81c89";
export var content = "FeaturedPanel-module--content--8ed20";
export var image = "FeaturedPanel-module--image--dcbf2";
export var imageLarge = "FeaturedPanel-module--image-large--1740b";
export var isCampaign = "FeaturedPanel-module--is-campaign--2868d";
export var isCampaignContent = "FeaturedPanel-module--is-campaign-content--e7f05";
export var isCampaignDesc = "FeaturedPanel-module--is-campaign-desc--3dccb";
export var lgPanel = "FeaturedPanel-module--lg-panel--92929";
export var noMaxWidth = "FeaturedPanel-module--no-max-width--68846";
export var panel = "FeaturedPanel-module--panel--11fe1";
export var smPanel = "FeaturedPanel-module--sm-panel--945b9";
export var svg = "FeaturedPanel-module--svg--f61f4";
export var visual = "FeaturedPanel-module--visual--bcd9a";